import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="text-center">
          <p className="font-display text-7xl text-primary-500 md:text-9xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这条线索暂时找不到
          </h1>
          <p className="mt-3 text-sm text-foreground-600">
            你访问的页面可能已被移动或不存在，回到首页继续浏览最新爆料吧。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 dark:text-foreground-950 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" aria-hidden="true"></i>
              返回首页
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              浏览全部分类
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}